// extracted by css-extract-rspack-plugin
export default {"my_games_block":"zEYli","myGamesBlock":"zEYli"};